import { createContext } from "react";

export type TNotificationType = 'success' | 'info' | 'warning' | 'error';
export interface INotificationsContextValue {
  showNotification: (type: TNotificationType, title: string, description?: string ) => void;
}

export const NotificationsContext = createContext<INotificationsContextValue | null>(null);